import auth from './auth';

export default {
  auth
}



// WEBPACK FOOTER //
// ./src/store/modules/index.js